import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { initialOrdersState, getUpdatedOrders } from './helpers';
import { OrderT, RequestStatus } from 'types';

const ordersSlice = createSlice({
  name: 'orders',
  initialState: initialOrdersState,
  reducers: {
    setCreateOrderStatus(state, action: PayloadAction<RequestStatus>) { 
      state.createOrderStatus = action.payload;
    },
    setOpenOrders(state, action: PayloadAction<OrderT[]>) { 
      state.openOrders = action.payload;
    },
    setUpdatedOrder(state, action: PayloadAction<OrderT>) { 
      const updatedOrdersList = getUpdatedOrders(state.openOrders, action.payload);
      state.openOrders = updatedOrdersList;
    },
    setOpenOrdersStatus(state, action: PayloadAction<RequestStatus>) { 
      state.openOrdersStatus = action.payload;
    },

    setClosedOrders(state, action: PayloadAction<{ closed_orders: OrderT[]; closed_orders_count: number }>) { 
      state.closedOrders = action.payload.closed_orders;
      state.closedOrdersCount = action.payload.closed_orders_count;
    },
    setClosedOrdersStatus(state, action: PayloadAction<RequestStatus>) { 
      state.closedOrdersStatus = action.payload;
    },
    setCurrentHistoryPage(state, action: PayloadAction<number>) { 
      state.currentHistoryPage = action.payload;
    },
    setCancelOrderStatus(state, action: PayloadAction<RequestStatus>) { 
      state.cancelOrderStatus = action.payload;
    }, 
  },
});

export const {
  setCreateOrderStatus,
  setOpenOrders,
  setUpdatedOrder,
  setOpenOrdersStatus,
  setClosedOrders,
  setClosedOrdersStatus,
  setCurrentHistoryPage,
  setCancelOrderStatus,
} = ordersSlice.actions;

export default ordersSlice.reducer;

